require('dotenv');
const axios = require('axios').default;

let ValidTimeslotsApi = {

    endpoint : "ValidTimeslots/",

    async getAll() {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;
        const response = await axios.get(URL, { withCredentials: true });
        return response;
    },

    async get() {
        throw "Cannot get single valid timeslots (they are dynamically generated by server)"
    },

    async add() {
        throw "Cannot add valid timeslots (they are dynamically generated on server-side)"
    },

    async update() {
        throw "Cannot update timeslots (they are dynamically generated on server-side)"
    }
}


export { ValidTimeslotsApi }